import React from 'react';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SITE_PATHS from '../../../config/sitePaths';
import { buildURL } from '../../../utils/urlHelpers';
import Auth0Client from '../../../auth/Auth0Client';

import './style.scss';

library.add(faCheckCircle);

const onSocialIconClicked = (props) => {
  const { scoringRequest } = props;
  if (props.connected) {
    const data = {
      connectionName: props.provider.connectionName,
      name: props.name,
      email: props.email,
      photoUrl: props.photoUrl,
      createdAt: props.createdAt,
    };
    props.history.push(SITE_PATHS.CONNECTED_SOCIAL_PROFILE, {
      providerName: props.provider.providerName,
      scoringRequest,
      data,
      imageSource: props.provider.imageSource,
    });
  } else {
    const { clientId, requestId } = scoringRequest;
    const request = {
      connection: props.provider.connectionName.toLowerCase(),
      prompt: 'login',
      redirectUri: buildURL(`${SITE_PATHS.SOCIAL_CONNECTORS_CALLBACK}?requestId=${requestId}&clientId=${clientId}`),
    };

    new Auth0Client().auth0.authorize(request);
  }
};

const createTileClassName = (connected) => {
  let className = 'social-button-image';

  if (connected) {
    className += ' connected';
  }

  return className;
};

const renderCircleCheckIcon = (connected) => {
  if (!connected) return null;

  return <FontAwesomeIcon className="circleCheckIcon" icon="check-circle" size="2x" />;
};

export default function SocialProviderTile(props) {
  return (
    <button
      type="button"
      onClick={() => onSocialIconClicked(props)}
      className="button provider"
      data-cy={`social-${props.provider.connectionName.toLowerCase()}`}
    >
      <img
        className={createTileClassName(props.connected)}
        alt={props.provider.providerName}
        src={props.provider.imageSource}
      />

      {renderCircleCheckIcon(props.connected)}

      <span>{props.provider.providerName}</span>
    </button>
  );
}
